import React, { useEffect } from "react";

export default function BatchInfoCard({ type, setBatchData, batchDatas, supplierName }) {
  let batchData = null;

  if (batchDatas) {
    batchData = batchDatas;
  } else if (type === "monitor" && !supplierName) {
    // Only pick from localStorage if supplierName is not provided
    const stored = localStorage.getItem("selectedRow");
    if (stored && stored !== "undefined" && stored !== "null") {
      try {
        batchData = JSON.parse(stored);
      } catch (err) {
        console.error("Error parsing batchDetails from localStorage:", err);
      }
    }
  }

  useEffect(() => {
    // Only setBatchData from localStorage if batchDatas is not provided, not in monitor mode, and supplierName is not provided
    if (!batchDatas && type !== "monitor" && !supplierName) {
      const initialBatch = localStorage.getItem("selectedRow");
      if (initialBatch && initialBatch !== "undefined" && initialBatch !== "null") {
        try {
          const parsedBatch = JSON.parse(initialBatch);
          setBatchData(parsedBatch);
        } catch (err) {
          console.error("Error parsing batchDetails from localStorage:", err);
        }
      }
    }
  }, [batchDatas, setBatchData, type, supplierName]);

  return (
    <div className="col-span-2  flex lg:flex-row flex-col px-3 py-2 space-y-3 lg:space-y-0 justify-between items-center rounded-md border dark-bg">
      <div className="w-full lg:w-auto flex justify-between lg:grid gap-y-3">
        <div>
          <p className="mb-0 text-xs">Production Order</p>
          <p className="mb-0 font-bold">{batchData?.purchaseRef}</p>
        </div>
        <div>
          <p className="mb-0 text-xs">Supplier</p>
          <p className="mb-0 font-bold">
            {supplierName || localStorage.getItem("supplierName")}
          </p>
        </div>
      </div>
      <div className="lg:w-px w-full lg:h-24 h-px bg-gray-200 light-bg mx-3"></div>
      <div className="w-full lg:w-auto flex justify-between lg:grid gap-y-3">
        <div>
          <p className="mb-0 text-xs">Raw Material</p>
          <p className="mb-0 font-bold">
            {batchData?.product?.name
              ? batchData?.product?.name +
              " " +
              (batchData?.productSize?.description ? batchData?.productSize?.description : "")
              : ""}
          </p>
        </div>
        <div>
          <p className="mb-0 text-xs">Batch Number</p>
          <p className="mb-0 font-bold">{batchData?.batchNumber}</p>
        </div>
      </div>
      <div className="lg:w-px w-full lg:h-24 h-px bg-gray-200 light-bg mx-3"></div>
      <div className="w-full lg:w-auto flex justify-between lg:grid gap-y-3">
        <div>
          <p className="mb-0 text-xs">Produced</p>
          {batchData?.intakeDate ? <p className="mb-0 font-bold">{(batchData?.intakeDate)?.split("T")[0]}</p> : null}
        </div>
        <div>
          <p className="mb-0 text-xs">Supplier Grade</p>
          <p className="mb-0 font-bold">N/A</p>
        </div>
      </div>
    </div>
  );
}
